import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { fg } from '@confluence/feature-gating';

import {
	FOUNDING_ADMIN_WITH_REVAMPED_BPQA,
	LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA,
} from '../../constants/onboarding-state/onboarding-constants';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql';

export const preloadLandUsersInEditorWithRevampedBpqa = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: fg('cfind-4971-improved-templates-bar-gate')
				? [
						...Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA),
						FOUNDING_ADMIN_WITH_REVAMPED_BPQA,
					]
				: [...Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA)],
		},
	});
};
